/*
 * @Author: zyq
 * @Date: 2022-10-19 09:57:01
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-23 20:41:26
 * @description:
 */

export function getToken () {
  return localStorage.getItem('token')
}
